import { createAction, props } from '@ngrx/store';
import { CompanyInactivePeriodDto } from '../../models/api/companyInactivePeriodDto';

export const setActiveCompany = createAction(
    '[Company Form] Set Active Company',
    props<{ companyId: string }>()
);

export const setTabYear = createAction(
    '[Company Form] Set Tab Year',
    props<{ tabId: string; year: string }>()
);

export const clearCompanyCache = createAction(
    '[Company Form] Clear Company Cache'
);

export const setCompanyCode = createAction(
    '[Company Form] Set Company Code',
    props<{ companyCode: string | null }>()
);

export const setCompanyName = createAction(
    '[Company Form] Set Company Name',
    props<{ companyName: string }>()
);

export const setCompanyCountry = createAction(
    '[Company Form] Set Company Country',
    props<{ companyCountry: string | null }>()
);

export const setDefaultYear = createAction(
    '[Company Form] Set Default Year',
    props<{ year: string }>()
);

export const loadInactivePeriods = createAction(
    '[Company Form] Load Inactive Periods',
    props<{ companyId: string }>()
);

export const loadInactivePeriodsSuccess = createAction(
    '[Company Form] Load Inactive Periods Success',
    props<{ inactivePeriods: CompanyInactivePeriodDto[] }>()
);

export const loadInactivePeriodsFailure = createAction(
    '[Company Form] Load Inactive Periods Failure',
    props<{ error: string }>()
);
